import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import { analyticsMarketplaceTradersKey } from '~/api/service/query-keys.const'
import { IAnalyticsParam, IAnalyticsPeriod } from '~/types/analytics.type'
import { LineChartModel } from '~/types/model/analytics.model'

export const analyticsMarketplaceService = {
  useGetMarketplaceTraders: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getMarketplaceTraders = async () => {
      const res = await explorerApi.analyticsController.getMarketplaceTraders({
        requestBody:{
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }
    return useQuery([ ...analyticsMarketplaceTradersKey, params ], getMarketplaceTraders, {
      enabled: isEnable,
    })
  }
}